// extracted by mini-css-extract-plugin
export default {"paginator":"paginator_paginator__n+JAx","pageButton":"paginator_pageButton__fMtNJ","isActive":"paginator_isActive__YTfRW","ellipsis":"paginator_ellipsis__SIMfb"};